import 'url-search-params-polyfill';

export const getDualMatchProfile = (axiosInstance, eventId) => {
    const url = `v1/events/dualmatches/${eventId}`;
    console.log('URL', url);
    return axiosInstance.get(url);
};

export const updateEventTeamScores = (axiosInstance, eventId, data) => {
    return axiosInstance.put(`v1/tms/events/${eventId}/team-scores`, data);
};

export const updateMatchPositions = (axiosInstance, matchId, data) => {
    return axiosInstance.put(`v1/tms/matches/${matchId}/positions`, data);
};

export const addMatchToRound = (axiosInstance, roundId, data) => {
    return axiosInstance.post(`v1/tms/rounds/${roundId}/matches/add`, data);
};

export const deleteMatch = (axiosInstance, matchId) => {
    return axiosInstance.delete(`v1/tms/matches/${matchId}`);
};

export const addDraw = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`v1/tms/events/${eventId}/draws/add`, data);
};

export const updateDraw = (axiosInstance, eventId, drawId, data) => {
    return axiosInstance.put(`v1/tms/events/${eventId}/draws/${drawId}`, data);
};

export const contactSelectedMembers = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`/v1/tms/events/${eventId}/notify`, data);
};

export const invitePlayersToEvent = (axiosInstance, eventId, playersList) => {
    const url = `v1/tms/events/${eventId}/invite`;
    return axiosInstance.post(url, playersList);
};

export const uploadEventAttachment = (axiosInstance, eventId, formData) => {
    const url = `v1/tms/events/${eventId}/file`;
    return axiosInstance.post(url, formData);
};

export const getEventAttachments = (axiosInstance, eventId) => {
    const url = `v1/tms/events/${eventId}/files`;
    return axiosInstance.get(url);
};

export const deleteEventAttachment = (axiosInstance, eventId, fileId) => {
    const url = `v1/tms/events/${eventId}/file/${fileId}`;
    return axiosInstance.delete(url);
};

export const getOrderOfPlay = (axiosInstance, eventId) => {
    const url = `/v1/tms/events/${eventId}/order-of-play`;
    return axiosInstance.get(url);
};

export const saveOrderOfPlay = (axiosInstance, eventId, oop) => {
    const url = `/v1/tms/events/${eventId}/order-of-play`;
    return axiosInstance.put(url, oop);
};

export const deleteOrderOfPlay = (axiosInstance, eventId, matchId) => {
    const url = `/v1/tms/events/${eventId}/order-of-play/match/${matchId}`;
    return axiosInstance.delete(url);
};

export const sortEventAttachments = (axiosInstance, eventId, items) => {
    return axiosInstance.put(`v1/tms/events/${eventId}/files/sort-order`, { items });
};

export const postNcsaReg = (axiosInstance, payload) => {
    const url = `/v1/member/ncsa-survey`;
    return axiosInstance.post(url, payload);
};
